"use client";
import { t } from "./tv.config-BuYIgndg.mjs";
const a = t({
  base: ["border-collapse table-auto w-full text-sm overflow-auto"],
  variants: {},
  defaultVariants: {}
}), s = t({
  base: [""],
  variants: {
    isSticky: {
      true: "sticky top-0 bg-white border-b"
    }
  }
});
t({
  base: ["bg-white"],
  variants: {}
});
const r = t({
  base: ["group"],
  variants: {}
}), l = t({
  base: ["transition-all"],
  variants: {
    td: {
      true: "border-b border-slate-100  text-slate-500 group-last:border-b-0"
    },
    th: {
      true: "border-b font-medium  text-slate-700  text-left"
    },
    size: {
      small: ["px-4", "py-2"],
      medium: ["p-4"]
    }
  },
  defaultVariants: {
    td: !0,
    size: "medium"
  }
});
export {
  s as a,
  l as b,
  a as c,
  r as t
};
